var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyCiconsSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.43,
    width: 32,
    height: 23.143,
    rx: 2,
    fill: "#8AB6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.43,
    y: 10.145,
    width: 16.143,
    height: 1.714,
    rx: 0.857,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.43,
    y: 14.715,
    width: 9.143,
    height: 1.714,
    rx: 0.857,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.856 32a9.143 9.143 0 1 0 0-18.285 9.143 9.143 0 0 0 0 18.286z",
    fill: "#226DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.305 20.091c.297-.63.79-.785 1.19-.892.261-.07.537-.07.808.08.244.136.415.358.546.556.38.572.551 1.285.628 1.871.118.91.035 1.736-.141 2.56-.058.27-.123.536-.193.797.084-.012.144-.053.213-.165.091-.145.157-.342.251-.625l.007-.02.058-.183c.037-.122.082-.265.12-.372.07-.2.167-.433.314-.638a.506.506 0 0 1 .526-.208.611.611 0 0 1 .31.18c.086.09.144.197.172.25.035.066.065.132.085.179l.025.058.001.004.124.25c.042.086.081.167.12.243.038-.067.077-.134.117-.2.1-.163.226-.354.358-.488a.767.767 0 0 1 .34-.212.563.563 0 0 1 .36.024.65.65 0 0 1 .3.258 3.977 3.977 0 0 1 .15.268c0 .003.002.005.003.007a5.66 5.66 0 0 1 .526-.438l.018-.013c.062-.043.172-.12.29-.18a.885.885 0 0 1 .607-.086c.13.032.25.086.325.12l.01.005c.09.04.13.057.164.066.225.059.502-.01.875-.14.447-.155.868-.373 1.322-.608l.328-.168c.058-.03.101-.054.152-.083l.154-.086c.118-.063.267-.137.434-.181.276-.074.565.109.645.41.08.3-.078.603-.354.677a1.11 1.11 0 0 0-.227.1l-.1.055c-.073.041-.161.09-.228.124l-.297.153c-.458.238-.953.494-1.472.674-.34.119-.884.304-1.436.161-.126-.033-.243-.086-.317-.12l-.013-.005a2.439 2.439 0 0 0-.106-.046.807.807 0 0 0-.078.046l-.079.055-.023.016a3.721 3.721 0 0 0-.391.328c-.082.075-.172.157-.282.251a.679.679 0 0 1-.711.126 1.023 1.023 0 0 1-.42-.344 11.929 11.929 0 0 0-.231.417l-.07.129-.001.002a1.517 1.517 0 0 1-.095.157.862.862 0 0 1-.12.136.555.555 0 0 1-.32.142.575.575 0 0 1-.38-.106.856.856 0 0 1-.163-.153 3.731 3.731 0 0 1-.421-.645 6.675 6.675 0 0 1-.037.11c-.08.24-.184.558-.347.82-.197.313-.5.585-.969.63a2.363 2.363 0 0 1-.446-.002c-.09.309-.205.694-.386 1.013a.489.489 0 0 1-.713.164.598.598 0 0 1-.182-.775c.117-.207.183-.432.268-.719l.017-.059a1.356 1.356 0 0 1-.255-.271c-.563-.796-.863-1.628-1.103-2.523l-.065-.235c-.092-.33-.201-.724-.258-1.106-.074-.49-.079-1.052.169-1.576zm1.874 4.477c.052-.197.099-.396.142-.595.157-.739.22-1.423.125-2.157-.067-.508-.205-1.008-.436-1.357a1.25 1.25 0 0 0-.116-.154.27.27 0 0 0-.033-.032 1.403 1.403 0 0 0-.45.15.444.444 0 0 0-.174.208c-.111.237-.13.53-.074.904.045.3.128.598.217.92l.079.286c.186.696.395 1.284.72 1.827zm2.02-.79.002.002-.002-.002zm2.485.371-.007.006a.039.039 0 0 1 .007-.006zm.545-.268-.003-.003a.03.03 0 0 1 .003.003zm-1.44.65.001.001z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyCiconsSign);
export default __webpack_public_path__ + "static/media/KYCiconsSign.8a6f72cbb364257fb936d7952954c5f5.svg";
export { ForwardRef as ReactComponent };